<div>
  <h1 class="app">Start a Quote</h1>
</div>
<lib-program-tiles (onTileSelect)="handleTileSelect($event)"></lib-program-tiles>